import { Dropdown } from '@cmsgov/ds-medicare-gov';
import React from 'react';
import translate from '../functions/translate';

export default function SuffixDropdown(props) {
    const suffixOptions = [
        {label: translate('None'), value: ''},
        {label: 'Jr', value: 'Jr'},
        {label: 'Sr', value: 'Sr'},
        {label: 'I', value: 'I'},
        {label: 'II', value: 'II'},
        {label: 'III', value: 'III'},
        {label: 'IV', value: 'IV'},
        {label: 'V', value: 'V'},
        {label: 'VI', value: 'VI'},
        {label: 'VII', value: 'VII'},
    ];
   
    return <>
        <Dropdown
            label={translate('Suffix')}
            name={'suffix'}
            options={suffixOptions}
            {...props}
        />
    </>;
}